import React from 'react';

type Props = {
  size?: number;
  className?: string;
  color?: string;
};

export const HomeDelivery = ({
  size = 16,
  className,
  color = '#707070',
}: Props) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect id="bounding-box" x="0" y="0" width="32" height="32" />
        <path
          d="M23.5,12 L21,12 L21,10 C21,8.9 20.1,8 19,8 L7,8 C5.9,8 5,8.9 5,10 L5,19 C5,20.1 5.9,21 7,21 C7,22.66 8.34,24 10,24 C11.66,24 13,22.66 13,21 L19,21 C19,22.66 20.34,24 22,24 C23.66,24 25,22.66 25,21 L26,21 C26.55,21 27,20.55 27,20 L27,16.67 C27,16.24 26.86,15.82 26.6,15.47 L24.3,12.4 C24.11,12.15 23.81,12 23.5,12 Z M10,22 C9.45,22 9,21.55 9,21 C9,20.45 9.45,20 10,20 C10.55,20 11,20.45 11,21 C11,21.55 10.55,22 10,22 Z M23.5,13.5 L25.46,16 L21,16 L21,13.5 L23.5,13.5 Z M22,22 C21.45,22 21,21.55 21,21 C21,20.45 21.45,20 22,20 C22.55,20 23,20.45 23,21 C23,21.55 22.55,22 22,22 Z"
          id="Shape"
          fill={color}
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};
